import { z } from 'zod';

export const QuotesProductType = z.enum(['MEDICARE_ADVANTAGE', 'MEDIGAP']);

export type QuotesProductType = z.infer<typeof QuotesProductType>;
